import emptyStateImg from "../assets/empty.png";
import Help from "./Help";
import { helpPagesData } from "../utils/helper";
import { NavLink } from "react-router-dom";

const EmptyStateOrganization = () => {
  return (
    <div className="empty-state">
      <img src={emptyStateImg} alt="Empty State" className="empty_img" />
      <div className="empty_ttl">No Organization Yet</div>
      <div className="empty_desc">
        Start by creating a new ORganization and add Create Projects in it. Manage and customize them easily from here.
      </div>
      <div className="empty_btn-box">
        <Help
          title={helpPagesData.pages.title}
          message={helpPagesData.pages.message}
          items={helpPagesData.pages.items}
        />
        <NavLink to="/organization/add-organization" className="btn-black">
          Add New Organization
        </NavLink>
      </div>
    </div>
  );
};

export default EmptyStateOrganization;
